// src/renderer.tsx
import { createFormRenderer, deepMerge } from "@react-typed-forms/schemas";
import {
  createDefaultRenderers,
  DefaultRendererOptions,
  defaultTailwindTheme,
  OptionalEditRenderer,
} from "@react-typed-forms/schemas-html";
import { createSignatureRenderer } from "@astroapps/schemas-signature";

// Default render options
const defaultRenderers = createDefaultRenderers(
  deepMerge<DefaultRendererOptions>(
    {
      label: { className: "font-bold text-surface-700" },
      group: { grid: { defaultColumns: 1 } },
      action: {
        buttonClass: "btn",
        primaryClass: "btn-primary",
        secondaryClass: "btn-secondary",
      },
      layout: { errorClass: "text-sm text-danger-500 mt-1" },
      data: {
        // inputClass defaults to "form-control" (styled in App.css)
        multilineClass: "form-control min-h-24 whitespace-pre-wrap",
        checkOptions: {
          className: "flex items-center gap-4",
          entryClass: "flex items-center gap-1.5 accent-primary-500",
        },
      },
      adornment: {
        optional: {
          customRender: (props) => {
            return (
              <OptionalEditRenderer
                {...props}
                renderMultiValues={(v) =>
                  v.value
                    .map((x) => (x == null ? "<null>" : x.toString()))
                    .join(", ")
                }
              />
            );
          },
        },
      },
    },
    defaultTailwindTheme,
  ),
);

const signatureRenderer = createSignatureRenderer({});

export const formRenderer = createFormRenderer(
  [signatureRenderer],
  defaultRenderers,
);
